"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = _interopRequireDefault(require("immutable"));

var _formatters = require("../utils/formatters");

var defaults = {
  category: '',
  companyName: '',
  firstPublishedAt: 0,
  hubInstalls: 0,
  iconUrl: '',
  id: 0,
  installed: false,
  minCents: null,
  minCommitmentCents: null,
  minPlanType: null,
  name: '',
  nativeId: '',
  offeringId: 0,
  pricingsCount: 0,
  reviewSummary: null,
  slug: '',
  tagline: ''
};

var ThinListing = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(ThinListing, _Immutable$Record);

  function ThinListing(values) {
    (0, _classCallCheck2.default)(this, ThinListing);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ThinListing).call(this, (0, _formatters.cleanObject)(values)));
  }

  return ThinListing;
}(_immutable.default.Record(defaults));

var _default = ThinListing;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/records/ThinListing.js
// module id = 184
// module chunks = 209 210 211 212 213